import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { DialogTitle } from 'base-ui'

export const DirectContactFormHookFormDialogTitle: FC<{
  isSuccess: boolean
  onClose: () => void
}> = ({ isSuccess, onClose }) => (
  <DialogTitle onClose={onClose}>
    <span
      data-qa-id={
        isSuccess
          ? 'direct-contact-form-submit-success-message'
          : 'direct-contact-form-label-title'
      }
    >
      {isSuccess ? (
        <FormattedMessage id="direct.contact.form.submit.success.message" />
      ) : (
        <FormattedMessage id="general.label.contactForm" />
      )}
    </span>
  </DialogTitle>
)
